import React, { useState, useEffect } from "react";
import { Modal, Table, Spinner } from "react-bootstrap";
import { formatDateInDDMMYYYY } from "../../functions/common-functions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import errorImage from "../../icons/error-tick-logo.svg";
import { getEnquiryReport } from "../../services/enquiry-reports-service";
import { getComparisonSheetData } from "../../services/finalize-bid-service";

const ComparisonSheetView = ({ show, onHide, enquiryNumber }) => {
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [enquiryData, setEnquiryData] = useState(null);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    if (show && enquiryNumber) {
      fetchComparisonData();
    }
  }, [show, enquiryNumber]);

  const fetchComparisonData = async () => {
    setLoading(true);
    try {
      // Fetch customer bids for the enquiry
      const allBids = await getEnquiryReport();
      console.log("allBids", allBids);

      // Filter bids for the specific enquiry number
      const enquiryBids = allBids.filter(bid => bid.EnquiryNumber === enquiryNumber);
      const tempEnquiryNumber = enquiryBids[0].EnquiryNumber;
      const data = await getComparisonSheetData({ EnquiryNumber: tempEnquiryNumber });
      setEnquiryData(data.enquiryData);
      // setEnquiryData({
      //   EnquiryNumber: firstRecord.EnquiryNumber,
      //   EnquiryStatus: firstRecord.EnquiryStatus,
      //   DueDate: firstRecord.DueDate,
      //   ItemCode: firstRecord.ItemCode,
      //   ItemDescription: firstRecord.ItemDescription,
      //   ItemDetail: firstRecord.ItemDetail,
      //   Quantity: firstRecord.Quantity,
      //   UOM: firstRecord.UOM,
      //   GST: firstRecord.GST,
      //   Location: firstRecord.Location,
      //   Division: firstRecord.Division,
      //   DueDate: firstRecord.DueDate,
      //   EnquirySource: firstRecord.EnquirySource,
      //   EnquirySourceNumber: firstRecord.EnquirySourceNumber,
      //   Remarks: firstRecord.Remarks
      // });


      if (enquiryBids && enquiryBids.length > 0) {
        // Map customer data from each bid record
        const customerList = enquiryBids.map(record => ({
          CustomerEmail: record.CustomerEmail,
          CustomerUserName: record.CustomerUserName,
          CustomerCode: record.CustomerCode,
          CurrentBid: record.CurrentBid,
          CurrentBidDate: record.CurrentBidDate,
          BidStatus: record.BidStatus
        }));
        console.log("customerList", customerList);

        // Sort by bid amount (highest first)
        const sortedCustomers = customerList.sort((a, b) => {
          const bidA = parseFloat(a.CurrentBid) || 0;
          const bidB = parseFloat(b.CurrentBid) || 0;
          return bidB - bidA;
        });
        console.log("sortedCustomers", sortedCustomers);
        setCustomers(sortedCustomers);
      } else {
        MySwal.fire({
          text: "No data found for this enquiry",
          imageUrl: errorImage,
          customClass: "swal-error",
        });
        onHide();
      }
    } catch (error) {
      console.error("Error fetching comparison data:", error);
      MySwal.fire({
        text: "Error loading comparison sheet data",
        imageUrl: errorImage,
        customClass: "swal-error",
      });
    }
    setLoading(false);
  };

  return (
    <>
      {loading && <div className="spinner-box"><Spinner animation="border" className="spinner" /></div>}

      <Modal show={show} onHide={onHide} size="xl" backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>Comparison Sheet - {enquiryNumber}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {enquiryData && (
            <>
              {/* Enquiry Details Table */}
              <div className="mb-4">
                <h5>Enquiry Details</h5>
                <Table bordered size="sm">
                  <tbody>
                    <tr>
                      <td><strong>Enquiry Number</strong></td>
                      <td>{enquiryData.EnquiryNumber || "-"}</td>
                      <td><strong>Enquiry Status</strong></td>
                      <td>{enquiryData.EnquiryStatus || "-"}</td>
                      <td><strong>Due Date</strong></td>
                      <td>{enquiryData.DueDate ? formatDateInDDMMYYYY(enquiryData.DueDate) : "-"}</td>
                    </tr>
                    <tr>
                      <td><strong>Item Code</strong></td>
                      <td>{enquiryData.ItemCode || "-"}</td>
                      <td><strong>Item Description</strong></td>
                      <td>{enquiryData.ItemDescription || "-"}</td>
                      <td><strong>Item Detail</strong></td>
                      <td>{enquiryData.ItemDetail || "-"}</td>
                    </tr>
                    <tr>
                      <td><strong>Quantity</strong></td>
                      <td>{enquiryData.Quantity || "-"}</td>
                      <td><strong>UOM</strong></td>
                      <td>{enquiryData.UOM || "-"}</td>
                      <td><strong>GST%</strong></td>
                      <td>{enquiryData.GST || "-"}</td>
                    </tr>
                    <tr>
                      <td><strong>Location</strong></td>
                      <td>{enquiryData.Location || "-"}</td>
                      <td><strong>Division</strong></td>
                      <td>{enquiryData.Division || "-"}</td>
                      <td><strong>Enquiry Source</strong></td>
                      <td>{enquiryData.EnquirySource || "-"}</td>
                    </tr>
                    <tr>
                      <td><strong>Enquiry Source Number</strong></td>
                      <td>{enquiryData.EnquirySourceNumber || "-"}</td>
                      <td><strong>Remarks</strong></td>
                      <td colSpan={3}>{enquiryData.Remarks || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>

              {/* Customer Comparison Table */}
              <div className="mb-4">
                <h5>Comparison Sheet</h5>
                <Table bordered size="sm" responsive>
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Customer Email</th>
                      <th>Customer Name</th>
                      <th>Customer Code</th>
                      <th>Current Bid (₹)</th>
                      <th>Bid Submission Date Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.length > 0 ? (
                      customers.map((customer, index) => {
                        const customerEmail = typeof customer.CustomerEmail === 'object'
                          ? Object.keys(customer.CustomerEmail)[0] || '-'
                          : customer.CustomerEmail || '-';

                        return (
                          <tr key={`${customerEmail}-${index}`}>
                            <td>{index + 1}</td>
                            <td>{customerEmail}</td>
                            <td>{customer.CustomerUserName || "-"}</td>
                            <td>{customer.CustomerCode || "-"}</td>
                            <td>
                              {customer.CurrentBid
                                ? (isNaN(customer.CurrentBid)
                                  ? customer.CurrentBid
                                  : `₹ ${parseFloat(customer.CurrentBid).toFixed(2)}`)
                                : "No Bid Placed"}
                            </td>
                            <td>{customer.CurrentBidDate || "-"}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center">No customers found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={onHide}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ComparisonSheetView;
